import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useMemo } from 'react'
import { format } from 'timeago.js'
import SvgCommercial from '#/assets/images/detail/commercial.svg'
import SvgCondo from '#/assets/images/detail/condo.svg'
import SvgHouse from '#/assets/images/detail/house.svg'
import SvgLand from '#/assets/images/detail/land.svg'
import SvgManufactured from '#/assets/images/detail/manufactured.svg'
import SvgMultiFamily from '#/assets/images/detail/multi-family.svg'
import SvgOther from '#/assets/images/detail/other-type.svg'
import SvgTimeshare from '#/assets/images/detail/timeshare.svg'
import SvgTownhouse from '#/assets/images/detail/townhouse.svg'
import Tooltip from '#/components/Tooltip'
import { getPropertyStatus } from '#/consts/property'
import cn from '#/utils/classnames'
import { status } from '#/utils/properties'

dayjs.extend(utc)

interface PropertyStatusProps {
  classes?: {
    root?: string
    updated?: string
  }
  property: TopHap.Property
  showExactDate?: boolean,
  showDate?: boolean
}

export const getIcon = (group: TopHap.PropertyUseGroup, use?: TopHap.PropertyUse) => {
  if (group === 'Residential') {
    if (use === 'House') {
      return SvgHouse
    } else if (use === 'Condo') {
      return SvgCondo
    } else if (use === 'Mobile / Manufactured Home') {
      return SvgManufactured
    } else if (use === 'Multi-family') {
      return SvgMultiFamily
    } else if (use === 'Townhouse') {
      return SvgTownhouse
    } else if (use === 'Timeshare') {
      return SvgTimeshare
    } else {
      return SvgTimeshare
    }
  } else if (group === 'Commercial') {
    return SvgCommercial
  } else if (group === 'Land') {
    return SvgLand
  } else {
    return SvgOther
  }
}

export default function PropertyStatus({
  classes,
  property,
  showExactDate,
  showDate = true
}: PropertyStatusProps) {
  const Icon = useMemo(
    () =>
      getIcon(property.PropertyUseGroup, property.PropertyUse),
    [property.PropertyUseGroup, property.PropertyUse]
  )

  const date =
    property.StandardStatus === 'Active' || property.isNew ?
      property.ListDate :
      property.TransactionDate

  const isInMonth = dayjs().subtract(1, 'month').isBefore(dayjs.utc(date))

  return (
    <div className={cn('text-2xs h-5 leading-5 text-white flex', classes?.root)}>
      <div
        className='z-10 min-w-[100px] whitespace-nowrap rounded-[10px] px-2 py-0 font-bold uppercase tracking-wide'
        style={{ background: getPropertyStatus(property).color }}
      >
        <Tooltip
          tooltip={
            property.StandardStatus === 'Sold' && property.RentFlag === true ?
              'Rented' :
              property.StandardStatus
          }
          trigger='hover'
          wrapClassName='flex items-center justify-center pr-0.5 h-full'
        >
          <Icon className='mr-2' />
          {status(property)}
        </Tooltip>
      </div>
      {date && showDate ? (
        <div className={cn('rounded-[10px] bg-black bg-opacity-80 pr-3 pl-7 -ml-5', classes?.updated)}>
          {!showExactDate && isInMonth ?
            format(date) :
            dayjs.utc(date).format('MM/DD/YYYY')}
        </div>
      ) : null}
    </div>
  )
}
